function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 2.684
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.34 52.301h-.807v-4.846l-3.884-4.35h-.04V17.452h.04l5.053-4.833h.032V4.35c0-.723-.56-1.308-1.251-1.308h-6.99v4.494l-3.924 1.3-3.615-1.3V3.042h-8.617v4.494l-3.616 1.3-3.923-1.3V3.042h-6.99c-.69 0-1.25.585-1.25 1.308v8.268h.014l5.071 4.833v25.655l-3.884 4.349V52.3h-.808c-.722 0-1.308.586-1.308 1.31v3.075c0 .722.586 1.308 1.308 1.308h39.387c.724 0 1.309-.586 1.309-1.308V53.61c0-.716-.586-1.307-1.31-1.307z",
  stroke: "#000",
  strokeLinecap: "square",
  strokeWidth: 0.7101327199999999
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  d: "M13.039 52.301h34.927M13.193 47.457h34.62M44.12 43.111H16.578M16.732 17.457h27.542M12.27 12.62h37.388",
  strokeWidth: 0.7101327199999999
}));

function SvgBlackRook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _ref);
}

export default SvgBlackRook;